module.exports = __webpack_public_path__ + "static/media/poop-yellow-type-6-copy-2.03059d9d.svg";